import React, { useState } from 'react';
import {Anchor, Button, Flex, Text, Title, Tooltip} from '@mantine/core';
import CancelSubscriptionModal from "@/PageComponents/Settings/Subscriptions/CancelSubscriptionModal";
import {IconCloudCancel} from "@tabler/icons-react";
import PS from '@/services/permission/permission-service';

interface CancelSubscriptionProps {
    onCancelCompleted: (cancelledRes: any) => void;
    isCancelled: boolean;
}


const CancelSubscription: React.FC<CancelSubscriptionProps> = ({ isCancelled, ...props }: any) => {
    const [showCancelModal, setShowCancelModal] = useState<boolean>(false);

    return (

        <>

            <Title order={5} mt={2} mb={12}>Your subscription</Title>

            <Flex w={'100%'} align={'center'} justify={'space-between'} gap={'sm'} >
                <Text size='sm' ta={'end'}>
                    Any queries? &nbsp;Please contact&nbsp;<Anchor href="mailto:support@servcraft.co.za">support@servcraft.co.za</Anchor>
                </Text>

                {!isCancelled &&
                    <Tooltip label={PS.isMasterSystemAdmin() ? "ServCraft Admin cannot cancel subscription" : ""} disabled={!PS.isMasterSystemAdmin()}>
                        <Button
                            onClick={
                                () => setShowCancelModal(true)
                            }
                            variant='light'
                            color='yellow.7'
                            type={'button'}
                            rightSection={<IconCloudCancel />}
                            disabled={PS.isMasterSystemAdmin()}
                        >
                            Cancel Subscription
                        </Button>
                    </Tooltip>
                }
            </Flex>

            <CancelSubscriptionModal onClose={() => setShowCancelModal(false)} open={showCancelModal} {...props} />
        </>
    )
}

export default CancelSubscription;